import {ClientCallType} from '@pexip/infinity/clientCallType';

import {valueToNumber} from './valueToNumber';

export const isClientCallType = (value: unknown): value is ClientCallType =>
    !!ClientCallType[valueToNumber(value)];
